import { LogsBarInner } from './helper/LogsBarInner'
import { LogsBarOuter } from './helper/LogsBarOuter'

interface Props {
  isBackLog?: boolean
}

export const LogsFront = ({ isBackLog = false }: Props): JSX.Element => {
  return (
    <>
      <LogsBarOuter isBackLog={isBackLog} />
      <LogsBarInner isBackLog={isBackLog} />
    </>
  )
}
